import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

type HasImageIconProps = {
  hasImage: boolean;
  size?: "inherit" | "small" | "medium" | "large";
};

const HasImageIcon = ({ hasImage, size = "small" }: HasImageIconProps) => {
  if (hasImage) {
    return (
      <CheckCircleOutlineIcon
        color="success"
        fontSize={size}
        titleAccess="Has image"
      />
    );
  }

  return (
    <HighlightOffIcon
      color="error"
      fontSize={size}
      titleAccess="No image"
    />
  );
};

export default HasImageIcon;
